/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterEbsBlockDevice } from './emrClusterEbsBlockDevice';
import { EmrClusterInstanceTypeConfiguration } from './emrClusterInstanceTypeConfiguration';


export interface EmrClusterInstanceTypeSpecification { 
    /**
     * An EC2 instance type, such as 'm3.xlarge'.                
     */
    instanceType?: string;
    /**
     * The priority at which Amazon EMR launches the Amazon EC2 instances with this instance type.                
     */
    priority?: string;
    /**
     * The number of units that a provisioned instance of this type provides toward fulfilling the target capacities defined in                   InstanceFleetConfig                
     */
    weightedCapacity?: number;
    /**
     * The bid price for each EC2 Spot instance type as defined by InstanceType.                
     */
    bidPrice?: string;
    /**
     * The bid price, as a percentage of On-Demand price, for each EC2 Spot instance as defined by InstanceType                
     */
    bidPriceAsPercentageOfOnDemandPrice?: string;
    /**
     * Evaluates to TRUE when the specified InstanceType is EBS-optimized                
     */
    ebsOptimized?: boolean;
    /**
     * The configuration of Amazon Elastic Block Storage (EBS) attached to each instance as defined by InstanceType                
     */
    ebsBlockDevices?: Array<EmrClusterEbsBlockDevice>;
    /**
     * A configuration classification that applies when provisioning cluster instances, which can include configurations for                   applications and software bundled with Amazon EMR                
     */
    configurations?: Array<EmrClusterInstanceTypeConfiguration>;
}
